import React, { useEffect, useState } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  Calendar,
  momentLocalizer,
  dateFnsLocalizer,
} from "react-big-calendar";
import moment from "moment";
import Header from "../../components/bars/Header";
import Sidebars from "../../components/bars/Sidebar";
import api from "../../api/api";
import { useNavigate } from "react-router-dom";
import "moment/locale/tr";
import tr from "date-fns/locale/tr";
import format from "date-fns/format";
import parse from "date-fns/parse";
import startOfWeek from "date-fns/startOfWeek";
import getDay from "date-fns/getDay";
import "./calendar.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useAuth } from "../../context/AuthContext";
import LoadingSpinner from "../LoadingSpinner";
import Breadcrumb from "../../components/bars/Breadcrumb";


const Calendars = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [assignedUser, setAssignedUser] = useState([]);
  const [myMeetings, setMyMeetings] = useState([]);
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken1 =
      localStorage.getItem("token") || sessionStorage.getItem("token");

    if (!user || !user.country) return;

    const fetchData = async () => {
      try {
        const taskRes = await api.get(
          `/api/Task/GetTasksByAssignedUser?customerID=${user.country}&userID=${user.nameidentifier}`
        );

        const formattedTasks = taskRes.data.map((task) => ({
          title: task.name,
          start: moment(task.startDate).toDate(),
          end: moment(task.endDate).toDate(),
          id: task.taskID,
          color: "#94a0df",
        }));

        setAssignedUser(formattedTasks);

        const meetingRes = await api.get(
          `/api/Meeting/GetMeetingsForUser?customerID=${user.country}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken1}`,
            },
          }
        );

        const formattedMeetings = meetingRes.data.map((meeting) => ({
          title: meeting.name,
          type: meeting.type,
          name: meeting.title,
          description: meeting.description,
          id: meeting.meetingID,
          start: moment(meeting.startDate).toDate(),
          end: moment(meeting.startDate)
            .add(meeting.duration, "minutes")
            .toDate(),
          color: "#e67c73",
        }));

        setMyMeetings(formattedMeetings);

        const notificationsRes = await api.get(
          `/api/UserNotification/GetNotifications?userID=${user.nameidentifier}&customerID=${user.country}&pageNumber=1&pageSize=99999`
        );

        const formattedNotifications = notificationsRes.data.items.map(
          (notif) => ({
            title: notif.notification,
            start: moment(notif.insertDate).toDate(),
            end: moment(notif.insertDate).add(3, "hours").toDate(),
            id: notif.notificationID,
            relationID: notif.relationID,
            type: notif.type,
            color: "#0C692F",
          })
        );

        setNotifications(formattedNotifications);
      } catch (error) {
        console.error("Error fetching tasks or meetings: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user]);

  const messages = {
    allDay: "Tüm gün",
    previous: "Önceki",
    next: "Sonraki",
    today: "Bugün",
    month: "Ay",
    week: "Hafta",
    day: "Gün",
    agenda: "Ajanda",
    date: "Tarih",
    time: "Saat",
    event: "Etkinlik",
    showMore: (total, meetings) => `+${total} daha`,
  };

  const locales = {
    tr: tr, // Türkçe dil dosyası
  };

  const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales,
  });

  const handleClick = (event) => {
    const isMeeting = myMeetings.some((meeting) => meeting.id === event.id);
    const isTask = assignedUser.some((task) => task.id === event.id);
    const notification = notifications.find((notif) => notif.id === event.id);

    if (isMeeting) {
      navigate(`../my-meetings`);
    } else if (isTask) {
      navigate(`../taskDetailByAssignedUser/${event.id}`);
    } else if (notification) {
      let linkTo = "";

      switch (notification.type) {
        case 122:
          linkTo = `/demandEdit/${notification.relationID}`;
          break;
        case 123:
          linkTo = `/offerEdit/${notification.relationID}`;
          break;
        case 124:
          linkTo = `/orderEdit/${notification.relationID}`;
          break;
        case 125:
          linkTo = `/invoiceEdit/${notification.relationID}`;
          break;
        case 126:
          linkTo = `/projectEdit/${notification.relationID}`;
          break;
        case 127:
          linkTo = `/taskDetailByAssignedUser/${notification.relationID}`;
          break;
        case 128:
          linkTo = `/formBuilderSchemaDetail/${notification.relationID}`;
          break;
        case 129:
          linkTo = `/stockCardEdit/${notification.relationID}`;
          break;
        case 130:
          linkTo = `/workFlowEdit/${notification.relationID}`;
          break;
        case 3794:
          linkTo = `/accountEdit/${notification.relationID}`;
          break;
        case 12:
          linkTo = `/shippingDetail/${notification.relationID}`;
          break;
        default:
          linkTo = "/notifications"; // Varsayılan yönlendirme
          break;
      }

      navigate(linkTo);
    }
  };

  return (
    <>
      <Header />
      <div className="flex">
        <Sidebars />
        {loading ? (
          <LoadingSpinner loading={loading} />
        ) : (
          <div className="flex-grow">
            <Breadcrumb breadcrumbData={[{ label: "Takvim", href: "" }]} />
            <div className="h-[100vh] m-12">
              <Calendar
                localizer={localizer}
                culture="tr"
                events={[...assignedUser, ...myMeetings, ...notifications]}
                startAccessor="start"
                endAccessor="end"
                onDoubleClickEvent={handleClick}
                views={["month", "week", "day"]}
                messages={messages}
                selectable={true}
                eventPropGetter={(event) => ({
                  style: {
                    backgroundColor: event.color,
                  },
                })}
              />
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Calendars;
